import type { RouteObject } from "react-router-dom";

import { LocationReload } from "@/components/atoms/location";
import { sentryCapture } from "@/lib/sentry";

type ImportError = {
  componentName: string;
  error: unknown;
};

export const handleDynamicImportError = ({
  componentName,
  error,
}: ImportError) => {
  console.log(`Failed to load ${componentName}`, error);
  sentryCapture.message(
    `Failed to fetch dynamically imported ${componentName}`
  );

  const storageKey = `react_router_reload:${componentName}`;
  if (!sessionStorage.getItem(storageKey)) {
    sessionStorage.setItem(storageKey, "1");

    return {
      Component: LocationReload,
    } satisfies RouteObject;
  }

  throw error;
};
